<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalProfile from "../DesignerQuestionTechnicalProfile.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalProfile,
            SynsealQuestion
        ],
        props: {
            frameMaterial: {
                required: true,
            }
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.frameMaterial, this.frameColourExternal, this.frameColourInternal, this.securedByDesign, this.hardwareHandle, this.hardwareEscutcheon, this.openingDirection);
            },
            url(){
                return '/api/options/' + this.fabricator + '/technical-profile?secured_by_design=' + this.securedByDesign + '&frame_material=' + this.frameMaterial + '&frame_colour_external=' + this.frameColourExternal + '&frame_colour_internal=' + this.frameColourInternal + '&hardware_handle=' + this.hardwareHandle + '&hardware_escutcheon=' + this.hardwareEscutcheon + '&opening_direction=' + this.openingDirection;
            },
            cache_key(){
                return '_' + this.frameMaterial + '_' + this.fabricator + '_' + this.frameColourExternal + '_' + this.frameColourInternal + '_' + this.securedByDesign + '_' + this.hardwareHandle + '_' + this.hardwareEscutcheon + '_' + this.openingDirection;
            },
        }
    }
</script>
